import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Select, Avatar, Tooltip, Icon } from 'antd';
import { GreenRoundCheck, CaretUpEmberIcon } from '../../../components/common/CustomIcon';
import { debounce, uniqBy } from 'lodash';

const SelectCustomSkills = React.memo((props) => {
  const [skillsList, setSkillsList] = useState([]);
  useEffect(() => {
    setSkillsList([...props.skills]);
  }, [props.skills.map(({ skill_id }) => skill_id).sort().join(',')]);

  const skillRender = (skill) => {
    const skill_note = props.getSkillNote ? props.getSkillNote(skill) : null;
    if ((skill.passed && parseInt(skill.passed, 10) === 1) || props.passed_skills.indexOf(skill.skill_id) >= 0) {
      return (
        <>
          <Avatar size="small" style={{ background: 'inherit' }} icon={<GreenRoundCheck />} />
          {skill.skill_name}
          {skill_note ? <span className="SkillsSelector-note">{skill_note}</span> : null}
        </>
      );
    } else if (skill.passed === null && parseInt(skill.mcq_exists, 10) === 1) {
      return (
        <Tooltip title="Test not yet taken">
          <Avatar size="small" style={{ background: 'inherit' }} icon={<CaretUpEmberIcon />} />
          {skill.skill_name}
          {skill_note ? <span className="SkillsSelector-note">{skill_note}</span> : null}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title="Test not yet taken">
          <Avatar size="small" style={{ background: 'inherit' }} icon={<Icon type="warning" width="16px" height="16px" style={{ color: '#888888' }} />} />
          {skill.skill_name}
          {skill_note ? <span className="SkillsSelector-note">{skill_note}</span> : null}
        </Tooltip>
      );
    }
  };

  const onSkillSearch = (value) => {
    const { base_skills, skills } = props;
    let allSkills = [];
    if (value === '') {
      allSkills = [...skills];
    } else {
      allSkills = [...skills, ...base_skills];
      allSkills = uniqBy(allSkills, skill => +skill.skill_id);
      allSkills = allSkills.filter(skill => skill.skill_name.toLowerCase().includes(value.toLowerCase()));
      allSkills = allSkills.slice(0, 20);
    }
    setSkillsList(allSkills);
  };

  const delayedQuery = useCallback(debounce(onSkillSearch, 500), []);

  const onSkillSelect = (value) => {
    if (!props.onSelect) return;
    delayedQuery('');
    props.onSelect(value);
  };

  return (
    <Select
      className={`${props.errors ? 'error' : ''}`}
      mode="multiple"
      style={{ width: '100%' }}
      defaultValue={props.activeProject.skills.map((skill) => skill.skill_id).filter((skill_id) => props.skillIds.includes(+skill_id))}
      placeholder="Technologies and tools used"
      optionLabelProp="label"
      showSearch
      onSelect={onSkillSelect}
      onSearch={delayedQuery}
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onChange={props.onSkillsChange}
    >
      {skillsList.map(skill => {
        return (
          <Select.Option key={skill.skill_id} value={parseInt(skill.skill_id, 10)} label={skillRender(skill)}>
            {skill.skill_name}
          </Select.Option>
        );
      })}
    </Select>
  );
});

SelectCustomSkills.propTypes = {
  errors: PropTypes.array,
  activeProject: PropTypes.object,
  skillIds: PropTypes.array,
  onSelect: PropTypes.func,
  onSkillsChange: PropTypes.func,
  getSkillNote: PropTypes.func,
  base_skills: PropTypes.array,
  skills: PropTypes.array,
  skills_inprogress: PropTypes.array,
  passed_skills: PropTypes.array
};

export default SelectCustomSkills;
